import { Button } from 'src/ui/common/atoms/button';
import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { Typography } from 'src/ui/common/atoms/typography';
import { SearchInput } from 'src/ui/common/molecules/search-input';
import styled from 'styled-components';

export const StyledMore = styled(Button)`
    margin-top: 20px;
    height: 30px;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
`;

export const StyledSearchInput = styled(SearchInput)`
    margin-bottom: 14px;

    & input {
        height: 45px !important;
    }

    & svg {
        top: 15px !important;
    }
`;

export const StyledNoData = styled(FlexBox)`
    margin-top: 20px;
    padding: 20px;

    & span {
        margin-top: 20px;
    }
`;

export const StyledNoFilterData = styled(Typography)`
    margin: auto;
    width: fit-content;
`;